import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { createStructuredSelector } from 'reselect';
import { makeErrorMessage } from '../selectors';
import { selectBundleIdList } from '../../App/actions';
import ModalSelector from '../../../components/Modals/ModalSelector';
import ModalMultipleSelector from '../../../components/Modals/ModalMultipleSelector';
import { ModalBundleSearchForm, ModalBundleSearchFormWithoutStatus } from '../../../components/PricingHub';

class ModalBundleItem extends PureComponent {
  render() {
    const tableConfig = {
      columns: [
        {
          name: 'id',
          label: 'common:label.id',
          render: (colName, item) => <span className="">{item.id}</span>,
        },
        {
          name: 'name',
          label: 'common:label.name',
          sortName: 'name',
        },
        {
          name: 'description',
          label: 'common:label.description',
        },
        {
          name: 'status',
          label: 'common:label.status',
          isRenderT: true,
          render: (colName, item, t) => {
            const slt = t ? t('selections:statusPricing')().find(val => val.value === item.status) : '';
            return <span>{slt ? slt.label : ''}</span>;
          },
        },
      ],
    };
    const { t, defaultSearchParams, isMultipe } = this.props;
    const ModalSelect = isMultipe ? ModalMultipleSelector : ModalSelector;
    return (
      <ModalSelect
        modalTitle={t('label.chooseBundle')}
        isOpen={this.props.isOpen}
        // SearchForm={ModalBundleSearchForm}
        SearchForm={
          defaultSearchParams && defaultSearchParams.status ? ModalBundleSearchFormWithoutStatus : ModalBundleSearchForm
        }
        searchItems={this.props.selectBundleIdList}
        tableColumns={tableConfig.columns}
        onSelect={this.props.onSelect}
        onCancel={this.props.onCancel}
        toggleModal={this.props.onCancel}
        isRequired={false}
        selectedParentId={this.props.selectedParentId}
        defaultSearchParams={this.props.defaultSearchParams}
      />
    );
  }
}

ModalBundleItem.propTypes = {
  isOpen: PropTypes.bool,
  isRequired: PropTypes.bool,
  onSelect: PropTypes.func,
  onCancel: PropTypes.func,
  selectedParentId: PropTypes.any,
  selectBundleIdList: PropTypes.func,
  errorMessage: PropTypes.string,
  defaultSearchParams: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  errorMessage: makeErrorMessage() || '',
});

const newModalBundleItem = connect(mapStateToProps, { selectBundleIdList })(ModalBundleItem);

export default withTranslation('common')(newModalBundleItem);
